import { defineMessages, IntlShape } from "react-intl";

import FrequencyType from "@mapmycustomers/shared/enum/FrequencyType";

import loggingService from "@app/util/logging";

const singularMessages = defineMessages({
  [FrequencyType.DAILY]: {
    id: "frequencyType.daily",
    defaultMessage: "Daily",
    description: "Daily frequency",
  },
  [FrequencyType.HOURLY]: {
    id: "frequencyType.hourly",
    defaultMessage: "Hourly",
    description: "Hourly frequency",
  },
  [FrequencyType.MONTHLY]: {
    id: "frequencyType.monthly",
    defaultMessage: "Monthly",
    description: "Monthly frequency",
  },
  [FrequencyType.WEEKLY]: {
    id: "frequencyType.weekly",
    defaultMessage: "Weekly",
    description: "Weekly frequency",
  },
});

const getFrequencyTypeDisplayName = (intl: IntlShape, frequencyType: FrequencyType): string => {
  try {
    return intl.formatMessage(singularMessages[frequencyType]);
  } catch (e) {
    loggingService.error("failed frequency type format", { e, frequencyType, singularMessages });
    return "";
  }
};

export default getFrequencyTypeDisplayName;
